import { I18n } from '@/i18n/I18n';
import { Placeholder } from 'react-bootstrap';
import { BasicButton } from '../buttons/BasicButton';

export function ProcedurePlaceholder() {
  return (
    <div className="w-100 d-flex" style={{position: 'relative', height: '90vh'}} data-bs-spy="scroll" data-bs-target="#navbarScroller" data-bs-offset="0" aria-label={I18n.get('loading')}>

      <aside key="side-nav" className='bd-sidebar bg-light'>
        <nav className="navbar flex-column align-items-stretch p-3 sticky-top" style={{'width': '250px'}} id='navbarScroller'>
          <nav aria-label="breadcrumb">
            <ul className="breadcrumb">
              <li className="breadcrumb-item ">
                <BasicButton className='p-0 btn btn-link' onClick={() => {}} label={I18n.get('veriform')} />
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <small>
                  {}
                </small>
              </li>
            </ul>
          </nav>
          <div className="d-flex flex-column">
            <Placeholder animation='wave'>
            {[...Array(10)].map((x, i) =>
              <Placeholder key={`placeholder-${i}`} xs={10} bg='secondary' />
            )}
            </Placeholder>
          </div>
        </nav>
      </aside>
      <ContainersPlaceholder />
    </div>
  );
}

export function ContainersPlaceholder() {
  return (
    <div className="d-flex flex-column w-100 px-5" aria-label={I18n.get('loading')}>
      <div className='py-3'>
        <Placeholder className='d-flex flex-column m-3' animation='wave'>
          <Placeholder.Button xs={12} size='lg' className='btn btn-secondary p-3' outline='true' />
          <div className='d-flex justify-content-between'>
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
          </div>
        </Placeholder>
      </div>
      <div className='py-3'>
        <Placeholder className='d-flex flex-column m-3' animation='wave'>
          <Placeholder.Button xs={12} size='lg' className='btn btn-secondary p-3' outline='true' />
          <div className='d-flex justify-content-between'>
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
          </div>
        </Placeholder>
      </div>
      <div className='py-3'>
        <Placeholder className='d-flex flex-column m-3' animation='wave'>
          <Placeholder.Button xs={12} size='lg' className='btn btn-secondary p-3' outline='true' />
          <div className='d-flex justify-content-between'>
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
            <Placeholder.Button xs={5} size='lg' className='my-4 p-3 btn btn-secondary' />
          </div>
        </Placeholder>
      </div>
    </div>
  );
}

